import "./commonstyle.css";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import useStore from "stores/Store";
import alrajhi_logo from "assets/images/alrajhi_logo.svg";
import { useLocation } from "react-router-dom";

function PromotionalBanner() {
  const { showBanner, setBanner } = useStore();
  const [promoData, setPromoData] = useState([]);

  const location = useLocation();

  const fetchPopupData = async () => {
    let url = `${process.env.REACT_APP_CMS_BASE_URL}/homepage-popups`;
    try {
      const response = await axios.get(url);

      setPromoData(response.data.data[0]);
      setBanner(response.data.data[0].isActive);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    if (location.pathname === "/") {
      fetchPopupData();
    }
  }, []);

  return (
    <Modal
      show={showBanner}
      onHide={() => setBanner(false)}
      centered
      size="lg"
      contentClassName="custom-modal-content"
    >
      <Modal.Header
        closeButton
        style={closeButtonStyle}
        className="custom-close-button"
      ></Modal.Header>
      <Modal.Body
        className="ping text-grey-color p-0 overflow-hidden"
        style={headerStyle}
      >
        <div className="d-flex flex-column">
          {promoData?.clickable ? (
            <a href={promoData?.redirectLink} target="_blank" rel="noreferrer">
              <img
                alt="Promo Image"
                src={`${promoData?.imageLink}`}
                width={"100%"}
                onError={(e) => (e.target.src = alrajhi_logo)}
              />
            </a>
          ) : (
            <img
              alt="Promo Image"
              src={`${promoData?.imageLink}`}
              onError={(e) => (e.target.src = alrajhi_logo)}
            />
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

const headerStyle = {
  borderRadius: "20px",
};

const closeButtonStyle = {
  position: "absolute",
  zIndex: 2,
  right: 0,
  padding: "18px",
};

export default PromotionalBanner;
